import React from 'react';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { FieldValues } from '../IMSFormFieldsTypes';

interface Component {
  id: React.Key | null | undefined;
  label_display: any;
  label: any;
  is_auto_populated?: boolean;
  component_response?: any; //
  datatype: string;
  values?: { id: React.Key | null | undefined; component_response: any; value: any }[];
}

interface Group {
    id: React.Key | null | undefined;
}

interface IMSFormAccordionSelectProps {
  component: Component;
  group: Group;
  fieldValues: FieldValues;
  handleFieldChange: (groupId: string | number, componentId: string | number, value: any, datatype: string) => void;
  shouldShowAutoPopulatedIndicator: (component: any, fieldValues: FieldValues) => boolean;
}

const IMSFormAccordionSelect: React.FC<IMSFormAccordionSelectProps> = ({
  component,
  group,
  fieldValues,
  handleFieldChange,
  shouldShowAutoPopulatedIndicator,
}) => {
  const AutoPopulateIndicator = () => (
    <FiberManualRecordIcon
      sx={{
        position: 'absolute',
        left: -30,
        top: '50%',
        transform: 'translateY(-50%)',
        color: '#209b2e',
        fontSize: '20px',
      }}
      titleAccess="Auto-populated from VIN"
    />
  );

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      {typeof component.id === 'number' &&
        shouldShowAutoPopulatedIndicator(
          {
            is_auto_populated: component.is_auto_populated,
            id: component.id as number,
            component_response: component.component_response,
            values: component.values,
          },
          fieldValues
        ) && <AutoPopulateIndicator />}
      <select
        title={component.label_display || component.label || 'Select option'}
        style={{
          width: '100%',
          padding: '5px',
          border: '1px solid #ccc',
          borderRadius: '3px',
          margin: '10px 0',
        }}
        onChange={(event) => {
            const target = event.target as HTMLSelectElement;
            if (group.id != null) { 
                handleFieldChange(
                  String(group.id), 
                  String(component.id),
                  target.value, 
                  component.datatype
                );
              }
        }}
      >
        {component.values?.map((option) => (
          <option key={option.id} value={option.component_response || ''}>
            {option.value}
          </option>
        ))}
      </select>
    </div>
  );
};

export default IMSFormAccordionSelect;
